var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UIContentBox',{staticClass:"flex items-center justify-center gap-5"},[_c('Button',{staticClass:"capitalize",attrs:{"loader":_vm.loading,"type":"primary","text":_vm.currentConfig.text,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit(_vm.currentConfig.event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }